import { render } from "./init_inquiry.vue?vue&type=template&id=388d8436&scoped=true"
import script from "./init_inquiry.vue?vue&type=script&lang=js"
export * from "./init_inquiry.vue?vue&type=script&lang=js"

import "./init_inquiry.vue?vue&type=style&index=0&id=388d8436&lang=scss"
import "./init_inquiry.vue?vue&type=style&index=1&id=388d8436&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d8436"]])

export default __exports__